<template>
  <header class="nav-bar">
    <div class="nav-bar__container">
      <div class="nav-bar__logo">
        <img class="nav-bar__logo-image" :src="companyLogo" :alt="companyName">
      </div>
      <div class="nav-bar__text">
        <span class="nav-bar__title">{{ title }}</span>
        <span class="nav-bar__divider" v-if="page"><feather-icon :icon="divider"/></span>
        <span class="nav-bar__page" v-if="page">{{ page }}</span>
      </div>
      <nav class="nav-bar__links">
        <ul>
          <li v-if="zoomEnabled" class="nav-bar__link" @click="toggleZoom" :class="{'nav-bar__link--active': isZoomed}">
            <feather-icon icon="zoom-in" @click="toggleZoom"/>
          </li>
          <li v-if="contentsEnabled" class="nav-bar__link" @click="toggleContents" :class="{'nav-bar__link--active': showContents}">
            <feather-icon icon="grid" />
          </li>
          <li v-if="searchEnabled" class="nav-bar__link" @click="toggleSearch" :class="{'nav-bar__link--active': showSearch}">
            <feather-icon icon="search" />
          </li>
          <li v-if="languagesEnabled" class="nav-bar__link" @click="toggleLanguages" :class="{'nav-bar__link--active': showLanguages}">
            <feather-icon icon="globe"/>
            <languages-panel v-show="showLanguages" />
          </li>
          <li v-if="downloadEnabled" class="nav-bar__link">
            <a :href="downloadPath" download><feather-icon icon="download"/></a>
          </li>
          <li v-if="printEnabled" class="nav-bar__link">
            <feather-icon icon="printer"/>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import FeatherIcon from './FeatherIcon.vue'
import LanguagesPanel from './LanguagesPanel.vue'

export default {
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon,
    LanguagesPanel,
  },
  computed: {
    ...mapGetters([
      'zoomEnabled',
      'contentsEnabled',
      'searchEnabled',
      'languagesEnabled',
      'downloadEnabled',
      'printEnabled',
      'rightToLeft',
      'companyLogo',
      'downloadPath',
      'showContents',
      'showLanguages',
      'showSearch',
      'isZoomed'
    ]),
    divider() {
      if(this.rightToLeft) return 'chevron-left'
      return 'chevron-right'
    }
  },
  methods: {
    ...mapMutations({
      toggleContents: 'TOGGLE_CONTENTS',
      toggleLanguages: 'TOGGLE_LANGUAGES',
      toggleZoom: 'TOGGLE_ZOOM',
      toggleSearch: 'TOGGLE_SEARCH',
    }),

  }
}
</script>

<style>
  .nav-bar {
    position: relative;
    z-index: 1;
    text-align: left;
    height: 48px;
    line-height: 48px;
    background-color: rgba(91, 71, 88, 1);
    color: white;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  .nav-bar__container {
    height: 100%;
    max-width: 100vw;
    margin: auto;
  }
  
  .nav-bar__logo {
    display: inline-block;
    vertical-align: middle;
    height: 60%;
    margin-right: 10px;
    margin-left: 10px;
  }

  .nav-bar__logo-image {
    max-height: 100%;
    max-width: calc(100vw - 250px);
  }

  .nav-bar__divider svg {
    position: relative;
    top: 6px;
    pointer-events: inherit;
  }

  .nav-bar__link svg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    pointer-events: inherit;
  }

  .nav-bar__links ul {
    margin: 0;
    padding: 0;
    height: 100%;
  }

  .nav-bar__links {
    float: right;
    cursor: pointer;
    height: 100%;
  }

  .nav-bar__links li a{
    color: #fff;
    text-decoration: none;
  }

  .nav-bar__link {
    float: left;
    border-color:  rgba(91, 71, 88, 1);
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-width: 0px;
    height: 100%;
    width: 48px;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;
    cursor: pointer;
  }

  .nav-bar__text {
    font-size: 0.9em;
    letter-spacing: 0.01em;
    font-weight: 700;
  }

  .nav-bar__link a {
    color: white;
  }

  .nav-bar__link:first-child {
    border-left-width: 2px;
  }

  .nav-bar__link:last-child {
    border-right-width: 2px;
  }

  .nav-bar__link--active {
    background-color: #00FFB4;
    border-color: white;
  }

  .nav-bar__link, .nav-bar__text {
    display: inline-block;
  }

  .right-to-left .nav-bar {
    direction: rtl;
    text-align: right;
  }

  .right-to-left .nav-bar__links {
    float: left;
  }

  .right-to-left .nav-bar__title, 
  .right-to-left .nav-bar__link {
    float: right;
  }

  .right-to-left .nav-bar__link:first-child {
    border-right-width: 2px;
    border-left-width: 1px;
  }

  .right-to-left .nav-bar__link:last-child {
    border-left-width: 2px;
    border-right-width: 1px;
  }

  @media (max-width: 950px) {
    .nav-bar__divider,
    .nav-bar__page {
      display: none;
    }
  }
  @media (max-width: 600px) {
    .nav-bar__text {
      display: none;
    }
  }

  @media (min-width: 600px) and (min-height: 600px) {
    .nav-bar__container{
      padding-left: 10px;
      padding-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue